"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAssetChildren = void 0;
const client_1 = require("@apollo/client");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
function useAssetChildren(locationId, parentAssetDid) {
    var _a, _b, _c, _d;
    const res = client_1.useQuery(CHILDREN_QUERY, {
        variables: { locationId, parentAssetDid },
        context: { locationId },
        fetchPolicy: 'cache-first',
    });
    return Object.assign(Object.assign({}, res), { data: (_d = (_c = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.unit) === null || _c === void 0 ? void 0 : _c.assetChildren) !== null && _d !== void 0 ? _d : null });
}
exports.useAssetChildren = useAssetChildren;
const CHILDREN_QUERY = graphql_tag_1.default `
  query GetAssetChildrenQuery($locationId: String!, $parentAssetDid: String!) {
    location(locationId: $locationId) {
      key
      unit(did: $parentAssetDid) {
        key
        assetChildren {
          key
          unitAddress {
            key
            did
            locationId
          }
          name
          unitTypeFixed
          assetChildren {
            key
            unitTypeFixed
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=useAssetChildren.js.map